import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "home-overlay h-100" }
const _hoisted_2 = {
  key: 0,
  class: "home-overlay-top-left f-row f-center-center"
}
const _hoisted_3 = { class: "home-overlay-bottom-left f-row-1 f-center-start" }
const _hoisted_4 = { class: "home-overlay-top-right" }
const _hoisted_5 = { class: "f" }
const _hoisted_6 = { class: "home-overlay-bottom-right f-row" }

import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { computed } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeOverlay',
  setup(__props) {

const route = useRoute();
const store = useStore();

const isHomePage = route.path === "/" ? true : false;
const isSignedIn = computed(() => store.getters.isSignedIn);

function openDiscord() {
    window.open("https://discord.gg/nKNXRhDng6", "_blank").focus();
}

return (_ctx: any,_cache: any) => {
  const _component_SimpleButton = _resolveComponent("SimpleButton")!
  const _component_SettingsIcons = _resolveComponent("SettingsIcons")!
  const _component_HomeOverlayAccount = _resolveComponent("HomeOverlayAccount")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isHomePage))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_SimpleButton, {
            class: "mr-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back())),
            style: {"--nth":"0.5s"},
            text: _ctx.$t.home.goBack,
            isSmall: "",
            icon: "chevron-left"
          }, null, 8, ["text"]),
          _createVNode(_component_SimpleButton, {
            to: "/",
            style: {"--nth":"0.6s"},
            isSmall: "",
            isIcon: "",
            icon: "home"
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_SettingsIcons)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_unref(isSignedIn))
        ? (_openBlock(), _createBlock(_component_HomeOverlayAccount, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        (!_unref(isSignedIn))
          ? (_openBlock(), _createBlock(_component_SimpleButton, {
              key: 0,
              to: "sign-in",
              isSmall: "",
              text: _ctx.$t.home.signIn,
              icon: "user"
            }, null, 8, ["text"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_SimpleButton, {
        class: "mr-2",
        isSmall: "",
        isIcon: "",
        icon: "brands fa-discord",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (openDiscord()))
      }),
      _createVNode(_component_SimpleButton, {
        to: "/about",
        text: _ctx.$t.home.about,
        isSmall: "",
        icon: "circle-info"
      }, null, 8, ["text"])
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})